export const LOGIN_USER = 'LOGIN_USER';
export const REGISTER_USER = 'REGISTER_USER';
export const CURRENT_USER = 'CURRENT_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_CONFIRM = 'RESET_PASSWORD_CONFIRM';
export const ACTIVATE_USER = 'ACTIVATE_USER';